
export enum ApiKeyEnum {
    ACCOUNT = 'ACCOUNT'
}

export interface IApiKeyConstant {
    name: string;
    key: string;
}
